import Element from "../element";

export default class SubmitButton extends Element {
	constructor(props) {
		super(props);

		this.endWithState = props.endWithState || 'common';
		this.manualFinishing = props.manualFinishing == null ? false : props.manualFinishing;
		this.data = props.data;

		this.animationDurationCount = 0;

		this.init();
	}

	enable() {
		this.$root.removeAttribute('disabled');
	}

	disable() {
		this.$root.setAttribute('disabled', 'disabled');
	}

	startCounting(submitStatusCallback) {

		return new Promise((done) => {
			this.animationDurationCount = 0;

			this.intervalId = setInterval(() => {

				if (submitStatusCallback) {
					const shouldFinish = submitStatusCallback();
					if (this.animationDurationCount >= 1500 && shouldFinish) {
						this.finishAnimation(done, (shouldFinish === 'interrupted'));
					}
				} else if (this.animationDurationCount >= 1500) {
					this.finishAnimation(done);
				}
				this.animationDurationCount += 100;
			}, 100);
		});
	}

	startAnimation(submitStatusCallback = null) {
		this.disable();
		this.$root.classList.add('-progress');

		return this.startCounting(submitStatusCallback);
	}

	finishAnimation(done, interrupt = false) {
		clearInterval(this.intervalId);
		this.$root.classList.remove('-progress');

		if (!interrupt) {
			this.$root.classList.add('-ready');

			if (this.endWithState === 'ready') {
				if (done) done();

			} else {
				setTimeout(() => {
					this.$root.classList.remove('-ready');
					if (done) done();
				}, 1200);
			}
		} else {
			done();
		}
	}

	refresh() {
		this.$root.classList.remove('-progress');
		this.$root.classList.remove('-ready');
		this.enable();
	}
}